<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944
    13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18
    9 18ZM7.80357 6.05316L11.8742 6.05321C11.9907 6.05312 12.1005
    6.09898 12.1833 6.18215C12.2663 6.26462 12.312 6.37445 12.3121
    6.49097V10.5616C12.3121 10.6778 12.2667 10.7873 12.1841
    10.8698C12.1015 10.9525 11.9924 10.9982 11.8762 10.9982L11.5072
    10.9988C11.3911 10.9988 11.2826 10.9543 11.2001 10.8718C11.1175
    10.7892 11.0741 10.6818 11.0741 10.5657L11.0782 8.16824L7.29246
    11.954C7.12238 12.1241 6.84141 12.1119 6.67128 11.9418L6.40998
    11.6805C6.23985 11.5104 6.24109 11.2428 6.41117 11.0727L10.1835
    7.30042L7.80614 7.2978C7.69008 7.29785 7.57801 7.24974 7.49544
    7.16717C7.41283 7.08456 7.36733 6.9751 7.36737 6.85904L7.36733 6.48941C7.36737 6.37326 7.41283
    6.26393 7.49548 6.18127C7.57805 6.09871 7.68738
    6.05316 7.80357 6.05316Z" fill="#04AB14"/>
  </svg>
</template>

<script>
export default {
  name: 'Subtract'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Icons/Subtract.vue